export default {
    type: 'checkbox',
    defaultWidth: '52px',
    header: false,
};
